import ApprovedApplications from "../Administration/ApprovedApplications";

const NagarApprovedApplications = ({ role }) => {
  return (
    <>
      <ApprovedApplications role={role} />
    </>
  );
};

export default NagarApprovedApplications;
